import { IconInfoCircle } from "@btnet/blueprint-icons";

interface IPleaseSelectJobHeaderProps {
    templatesOnly: boolean;
}

export function PleaseSelectJobHeader({ templatesOnly }: IPleaseSelectJobHeaderProps) {
    return (
        <div
            className="flex flex-row items-center gap-1 p-2 rounded-md bg-blue-10 text-blue-70 text-sm font-normal"
            data-testid="PleaseSelectJob"
        >
            <IconInfoCircle size="md" style={{ color: "var(--bui-token-color-blue-70)" }} />
            No {templatesOnly ? "template" : "job"} selected
        </div>
    );
}
